import { ApplicationType } from '@wix/editor-application';
import { EnvType } from './common';
export const Public = () => true;
export const Private = () => false;
export const Frame = (config) => [EnvType.Frame].includes(config.env);
export const Addon = (config) => config.type === ApplicationType.EditorAddon &&
    [EnvType.Worker, EnvType.Frame].includes(config.env);
//# sourceMappingURL=config.js.map